<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      consultas: null,
    };
  },
  methods: {
    getConsultas() {
      this.consultas = null;

      api
        .get('telemedicina/consultas')
        .then((response) => {
          if (response.data.status == 'success') {
            this.consultas = response.data.list;
          }
        })
    },
  },
  mounted() {
    this.getConsultas();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Minhas Consultas</h3>
        <p>Histórico completo de suas consultas.</p>
      </div>
    </div>

    <div v-if="!consultas" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="consultas && consultas.length == 0">
      <div class="card">
        <div class="card-body text-center">
          Nenhuma consulta encontrada.
        </div>
      </div>
    </div>

    <div v-else>
      <router-link class="d-block text-dark mb-2" tag="a" :to="'/telemedicina/consultas/' + row.id" v-for="(row, index) in consultas" :key="index">
        <div class="card card-icon mb-0">
          <div class="card-body d-flex align-items-center">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path>
                <path d="m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"></path>
              </svg>
            </div>
            <div class="ml-3 w-75 pt-1">
              <div class="badge badge-primary font-size-13 mb-2" v-if="row.status == 'created'">AGENDADO</div>
              <div class="badge badge-success font-size-13 mb-2" v-else-if="row.status == 'finalized'">FINALIZADO</div>
              <div class="badge badge-danger font-size-13 mb-2" v-else-if="row.status == 'unrealized'">NÃO REALIZADO</div>
              <div class="badge badge-danger font-size-13 mb-2" v-else-if="row.status == 'canceled'">CANCELADO</div>
              <p class="m-0 text-dark font-size-13 text-uppercase">{{ row.schedule.week }}</p>
              <p class="mb-1 text-dark"><strong>{{ row.schedule.date }} às {{ row.schedule.hour }}</strong></p>
              <h5 class="m-0 text-dark font-size-16"><strong>{{ row.professional.specialty }}</strong></h5>
              <p class="m-0 text-dark font-size-12">{{ row.professional.name }}</p>
            </div>
            <div class="ml-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
              </svg>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </Layout>
</template>